import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconGisMultipleSizeS from './IconGisMultiple_size_s';

const props: CreateIconArguments = {
  l: IconGisMultipleSizeS,
  m: IconGisMultipleSizeS,
  s: IconGisMultipleSizeS,
  xs: IconGisMultipleSizeS,
  name: 'IconGisMultiple',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
